import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { Button, InputWithLabel, Popover } from '@reveni-io/reveni-ui'

import AddVariablesButton from '@/common/components/AddVariablesButton/AddVariablesButton'

import * as Styles from './styles'

const AddLinkPopover = ({ toolbarRef, availableVariables, availableSections, show, onClose, onAddLink }) => {
  const [link, setLink] = useState('')
  const { t } = useTranslation()

  const onUseLinkVariable = variable => {
    setLink(variable.variable)
  }

  useEffect(() => {
    if (show) {
      setLink('')
    }
  }, [show])

  const handleOnAddLink = () => {
    onAddLink(link)
    onClose()
  }

  return (
    <Popover
      open={show}
      onClose={onClose}
      anchorEl={toolbarRef.current}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Styles.Container>
        <InputWithLabel
          label="URL"
          placeholder="https://example.com"
          value={link}
          onChange={e => setLink(e.target.value)}
        />
        <Tooltip title={t('Añadir variable')} position="top">
          <AddVariablesButton
            withLabel={false}
            availableVariables={availableVariables}
            availableSections={availableSections}
            onAddVariable={onUseLinkVariable}
          />
        </Tooltip>
        <Button size="s" variant="text" disabled={!link} onClick={handleOnAddLink}>
          {t('Guardar')}
        </Button>
      </Styles.Container>
    </Popover>
  )
}

export default AddLinkPopover
